(function () {
  'use strict';
  function validCode(code) { return /^[A-Za-z0-9][A-Za-z0-9._-]{1,39}$/.test(code); }
  function parseProduct(input, origin) {
    var value = input.trim();
    if (/^(?:www\.)?endopowersports\.com\//i.test(value) || /^xv1zde-0e\.myshopify\.com\//i.test(value)) value = 'https://' + value;
    var url;
    try { url = new URL(value, origin); } catch (e) { throw new Error('Paste a product link from endopowersports.com.'); }
    var hosts = [new URL(origin).hostname, 'endopowersports.com', 'www.endopowersports.com', 'xv1zde-0e.myshopify.com'];
    if (!/^https?:$/.test(url.protocol) || hosts.indexOf(url.hostname) === -1 || url.username || url.password || url.port) {
      throw new Error('Use a product link from endopowersports.com.');
    }
    var match = url.pathname.match(/^(?:\/collections\/[^/]+)?\/products\/([a-z0-9][a-z0-9-]*)\/?$/i);
    if (!match) throw new Error('Open the product you want to share and paste its page link here.');
    var variant = url.searchParams.get('variant');
    if (variant && !/^\d+$/.test(variant)) throw new Error('This product link has an invalid variant. Copy the link again from the product page.');
    return { handle: match[1], path: '/products/' + match[1], variant: variant };
  }
  function parseDestination(input, origin) {
    var value = input.trim();
    if (!value) return { kind: 'store', path: '/' };
    if (/^(?:www\.)?endopowersports\.com(?:\/|$)/i.test(value) || /^xv1zde-0e\.myshopify\.com(?:\/|$)/i.test(value)) value = 'https://' + value;
    var url;
    try { url = new URL(value, origin); } catch (e) { throw new Error('Use a link from endopowersports.com.'); }
    var hosts = [new URL(origin).hostname, 'endopowersports.com', 'www.endopowersports.com', 'xv1zde-0e.myshopify.com'];
    if (!/^https?:$/.test(url.protocol) || hosts.indexOf(url.hostname) === -1 || url.username || url.password || url.port) throw new Error('Use a link from endopowersports.com.');
    if (url.pathname === '/') return { kind: 'store', path: '/' };
    var collection = url.pathname.match(/^\/collections\/([a-z0-9][a-z0-9-]*)\/?$/i);
    if (collection) return { kind: 'collection', handle: collection[1], path: '/collections/' + collection[1] };
    var product = parseProduct(value, origin);
    product.kind = 'product';
    return product;
  }
  function buildLink(origin, product, code) {
    if (!validCode(code)) throw new Error('Enter your active affiliate code using 2–40 letters, numbers, dots, hyphens or underscores.');
    var destination = new URL(product.path, origin);
    if (product.variant) destination.searchParams.set('variant', product.variant);
    destination.searchParams.set('ref', code);
    var link = new URL('/discount/' + encodeURIComponent(code), origin);
    link.searchParams.set('redirect', destination.pathname + destination.search);
    return link.href;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { validCode: validCode, parseProduct: parseProduct, parseDestination: parseDestination, buildLink: buildLink };
  if (typeof window === 'undefined' || !window.customElements || customElements.get('endo-affiliate-links')) return;
  customElements.define('endo-affiliate-links', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      var root = this;
      var form = root.querySelector('[data-link-form]');
      var code = root.querySelector('[data-affiliate-code]');
      var productInput = root.querySelector('[data-product-url]');
      var generate = root.querySelector('[data-generate-link]');
      var status = root.querySelector('[data-link-status]');
      var result = root.querySelector('[data-link-result]');
      var output = root.querySelector('[data-generated-link]');
      var copy = root.querySelector('[data-copy-link]');
      var share = root.querySelector('[data-share-link]');
      var origin = new URL(root.dataset.origin).origin;
      var revision = 0;
      var incoming = new URLSearchParams(location.search).get('product');
      if (incoming) {
        try {
          var parsed = parseDestination(incoming, origin);
          var prefill = new URL(parsed.path, origin);
          if (parsed.variant) prefill.searchParams.set('variant', parsed.variant);
          productInput.value = prefill.href;
        } catch (e) { /* Untrusted prefill is ignored. */ }
      }
      function message(text, error) { status.textContent = text; status.dataset.error = error ? 'true' : 'false'; }
      form.hidden = false;
      form.addEventListener('input', function () {
        revision += 1;
        result.hidden = true;
        output.value = '';
        message('', false);
        copy.textContent = 'Copy link';
      });
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (!form.reportValidity()) return;
        var current = ++revision;
        result.hidden = true;
        generate.disabled = true;
        generate.textContent = 'Checking product…';
        message('', false);
        var timeout;
        try {
          var approvedCode = code.value.trim();
          var product = parseDestination(productInput.value, origin);
          var link = buildLink(origin, product, approvedCode);
          var details = { title: 'Endo Powersports' };
          if (product.kind !== 'store') {
            var controller = new AbortController();
            timeout = setTimeout(function () { controller.abort(); }, 12000);
            var endpoint = product.path + (product.kind === 'collection' ? '.json' : '.js');
            var response = await fetch(endpoint, { signal: controller.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('We could not find that page. Copy a current product or collection link from the shop.');
            details = await response.json();
            if (product.kind === 'collection') details = details.collection;
            if (!details || details.handle !== product.handle || typeof details.title !== 'string') throw new Error('We could not verify this page. Try its link again.');
            if (product.variant && (!Array.isArray(details.variants) || !details.variants.some(function (item) { return String(item.id) === product.variant; }))) {
              throw new Error('That variant is no longer listed. Copy a current link from the product page.');
            }
          }
          if (current !== revision) return;
          output.value = link;
          root.querySelector('[data-product-title]').textContent = details.title;
          var preview = new URL(product.path, origin);
          if (product.variant) preview.searchParams.set('variant', product.variant);
          root.querySelector('[data-preview-link]').href = preview.href;
          copy.textContent = 'Copy link';
          result.hidden = false;
          message('Your link is ready to copy. Use an active code linked to your affiliate account.', false);
        } catch (error) {
          if (current !== revision) return;
          message(error.name === 'AbortError' || error instanceof TypeError ? 'The page check could not connect. Please try again.' : error.message, true);
        } finally {
          clearTimeout(timeout);
          generate.disabled = false;
          generate.textContent = 'Create link';
        }
      });
      copy.addEventListener('click', async function () {
        if (!output.value || result.hidden) return;
        try {
          await navigator.clipboard.writeText(output.value);
          copy.textContent = 'Copied';
          message('Affiliate link copied.', false);
        } catch (error) {
          output.focus();
          output.select();
          message('Select and copy the link above to share it.', false);
        }
      });
      if (share && typeof navigator.share === 'function') {
        share.hidden = false;
        share.addEventListener('click', async function () {
          if (!output.value || result.hidden) return;
          try {
            await navigator.share({ title: 'Endo Powersports', text: 'Shop my Endo link. I may earn a reward on eligible purchases.', url: output.value });
          } catch (error) {
            if (error.name !== 'AbortError') message('Use Copy link to share your link.', false);
          }
        });
      }
    }
  });
})();
